var _path, _path2;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconQuote2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 885,
    height: 629,
    viewBox: "0 0 885 629",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 377.715H189.643L63.2132 630.571H252.856L379.285 377.715V-1.57056H0V377.715Z",
    fill: "#40A461"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M505.715 -1.57056V377.715H695.357L568.928 630.571H758.571L885 377.715V-1.57056H505.715Z",
    fill: "#40A461"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQuote2);
export default __webpack_public_path__ + "static/media/icon_quote_2.4d6ae0265268611a0fe2d73f9ba33e78.svg";
export { ForwardRef as ReactComponent };